export const API_ORGANIZATIONS_ORGANIZATIONID_USERS_AUTHORIZE_PATH_KEY =
  '/organizations/{organizationId}/users/authorize';
export const API_ORGANIZATIONS_ORGANIZATIONID_USERS_WARNINGS_PATH_KEY =
  '/organizations/{organizationId}/users/warnings';
export const API_ORGANIZATIONS_ORGANIZATIONID_SUBSCRIPTIONS_BILLING_LINK_PATH_KEY =
  '/organizations/{organizationId}/subscriptions/billing-link';
export const API_ORGANIZATIONS_ORGANIZATIONID_SUBSCRIPTIONS_PATH_KEY =
  '/organizations/{organizationId}/subscriptions';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTACTS_PATH_KEY =
  '/organizations/{organizationId}/contacts';
export const API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY =
  '/organizations/{organizationId}/delegations-assignees';
export const API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_GUEST_PATH_KEY =
  '/organizations/{organizationId}/delegations-assignees/guest';
export const API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_PATH_KEY =
  '/organizations/{organizationId}/delegations-assignees/{userId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_ACTIVATION_EMAIL_PATH_KEY =
  '/organizations/{organizationId}/delegations-assignees/{userId}/activation-email';
export const API_IDP_CONFIGURATIONS_PRODUCT_PRODUCTID_PATH_KEY =
  '/idp/configurations/product/{productId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_USERS_ACTIVE_CONTEXT_PATH_KEY =
  '/organizations/{organizationId}/users/active-context';
export const API_ORGANIZATIONS_ORGANIZATIONID_USERS_ME_PATH_KEY =
  '/organizations/{organizationId}/users/me';
export const API_ORGANIZATIONS_ORGANIZATIONID_USERS_ME_SET_ORGANIZATION_PATH_KEY =
  '/organizations/{organizationId}/users/me/set-organization';
export const API_ORGANIZATIONS_PATH_KEY = '/organizations';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_LINK_PATH_KEY =
  '/organizations/{organizationId}/config/design/link';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY =
  '/organizations/{organizationId}/config/design';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_COLORS_PATH_KEY =
  '/organizations/{organizationId}/config/colors';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_PATH_KEY =
  '/organizations/{organizationId}/config';
export const API_V1_ONBOARDING_PATH_KEY = '/v1/onboarding';
export const API_CHECK_CONFIRM_TOKEN_PATH_KEY = '/check/confirm-token';
export const API_CHECK_INVITATIONS_ACCEPT_PATH_KEY = '/check/invitations/accept';
export const API_BILLING_PUBLISH_METRICS_PATH_KEY = '/billing/publish-metrics';
export const API_BILLING_TRIAL_REMINDERS_SEND_PATH_KEY = '/billing/trial-reminders/send';
export const API_ORGANIZATIONS_ORGID_INVITE_EMPLOYEE_PATH_KEY =
  '/organizations/{orgId}/invite-employee';
